import AccessToken from "@/models/accessToken";

export default class Jwt {
  accessToken!: AccessToken;

  refreshToken = "";

  constructor(accessToken: AccessToken, refreshToken: string) {
    this.accessToken = accessToken;
    this.refreshToken = refreshToken;
  }
}
